import * as React from 'react';

function SvgSwiss(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 21h35.537V0H0v21z"
        fill="#E40000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 5h-3.333v4H12v3.333h3.667V16H19v-3.667h4V9h-4V5z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgSwiss;
